import type { ToolApprovalCardProps } from "#components/ui/tool-approval/renderers/ToolApprovalRenderer.types.ts";
import { AttendeeChips, DetailRow } from "#features/conversations/components/prepared-action/CalendarEventReadView.tsx";
import { DescriptionField, EDITABLE_FIELDS, OnlineMeetingSwitch, TitleField } from "#features/conversations/components/prepared-action/CalendarEventEditor.tsx";
import { attendeesOf, formatEventTime, recurrenceLabel } from "#features/conversations/components/prepared-action/calendarEventFields.ts";
import { EditErrors } from "#features/conversations/components/prepared-action/cardControls.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Text } from "@hopper-ui/components";
import { IconClock, IconPeople, IconRepeat, IconVideoCam } from "@intentui/icons";
import "./CalendarEventCard.css";

export function CalendarInviteDetails(props: ToolApprovalCardProps) {
    const { args, display, edits, editErrors, onEditArgs } = props;
    const { tShared, i18n } = useSharedTranslation();
    const shown = { ...args, ...edits };
    const when = formatEventTime(shown, i18n.language);
    const recurrence = recurrenceLabel(shown, tShared);
    const attendees = attendeesOf(shown, display ?? {}, tShared);

    return (
        <div className="wai-ce-details">
            {when !== null && <DetailRow glyph={<IconClock />}><Text size="sm">{when}</Text></DetailRow>}
            {recurrence !== null && <DetailRow glyph={<IconRepeat />}><Text size="sm">{recurrence}</Text></DetailRow>}
            {attendees.length > 0 && <DetailRow glyph={<IconPeople />}><AttendeeChips attendees={attendees} /></DetailRow>}
            <DetailRow glyph={<IconVideoCam />}>
                <OnlineMeetingSwitch args={shown} isDisabled={false} onChange={isOnline => onEditArgs({ is_online_event: isOnline })} />
            </DetailRow>
            <TitleField {...props} isDisabled={false} />
            <DescriptionField {...props} isDisabled={false} />
            <EditErrors errors={editErrors.filter(error => error.field === null || !EDITABLE_FIELDS.includes(error.field))} />
        </div>
    );
}
